import { cn } from "@/shared/lib/utils";
import { CardSkeleton } from "./chart-skeleton";

export function DashboardSkeleton({ className }: { className?: string }) {
	return (
		<div className={cn("grid grid-cols-2 gap-4", className)}>
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
			<CardSkeleton />
		</div>
	);
}
